/**
 * 마스킹 처리 합니다.
 */
export const replaceMasking = (data: string, maskingStartIndex: number) => {
    if (data !== undefined && data.length > maskingStartIndex) {
        const maskingString = data.substring(maskingStartIndex, data.length)
        let maskingResult = data.substring(0, maskingStartIndex)
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < maskingString.length; i += 1) {
            maskingResult += '*'
        }
        return maskingResult
    }
    return data
}

/**
 * 이메일에 마스킹 처리를 합니다.
 */
export const getMaskingEmail = (email: string) => {
    let result = email
    if (email !== undefined) {
        const emailArray = email.split('@')
        if (emailArray.length > 1) {
            const [emailId, domain] = emailArray
            if (!emailId || !domain) {
                return ''
            }

            // name: naver
            // extension: com
            const [name, extension] = domain.split('.')
            if (!name || !extension) {
                return ''
            }

            const maskedName = `${name.substring(0, 1)}*******`
            if (emailId.length > 2) {
                result = `${replaceMasking(emailId, 2)}@${maskedName}.${extension}`
            } else {
                result = `${emailId}@${maskedName}.${extension}`
            }
        }
    }
    return result
}

/**
 * 핸드폰 번호에 마스킹 처리를 합니다.
 */
export const getMaskingPhoneNumber = (phoneNumber: string) => {
    let result = phoneNumber
    if (phoneNumber !== undefined) {
        const telNoArray = phoneNumber.split('-')
        const size = telNoArray.length
        for (let i = 0; i < size; i += 1) {
            const telNumber = telNoArray[i]
            if (telNumber) {
                if (i === 0) {
                    result = telNumber
                } else {
                    result += `-${replaceMasking(telNumber, 1)}`
                }
            }
        }
    }
    return result
}

/**
 * 마스킹 정책
 * https://security.navercorp.com/regulation/content/M_CC2BEB14ABB64EA5BF0E9B171886AB8B
 * 마스킹 기준: 이용자 ID는 앞 4개를 제외하고 모두 마스킹. ID가 6자리 이하인 경우 ID의 앞 2자리만 남긴 뒤 4개 이상의 Asterisk(*)를 추가하여 붙이는 방법으로 마스킹.
 */
export const getMaskingId = (id: string) => {
    const size = id.length
    if (size <= 6) {
        return id.substring(0, 2) + '****'
    }
    return id.substring(0, 4) + id.substring(4, size).replace(/./gi, '*')
}
